<template>

  <group-card title="Credit Report" icon="price_check" :tooltipText="tooltipText">

    <v-tabs background-color = "#eeeeee">
      <v-tabs-slider color="#2E3485"></v-tabs-slider>
        <v-tab>
          Current
        </v-tab>
        <v-tab-item>
            <edit-applicant-privacy-consent
                v-model="applicant"
                :index="index"
                :privacy_consent="applicant.privacy_consent"
                :version="'Current'"
            />

            <edit-applicant-credit-report-content
                v-model="applicant"
                :version="'Current'"
                :index="index"
                :application="application"
            />
        </v-tab-item>

        <v-tab>Previous</v-tab>
        <v-tab-item>
        <edit-applicant-privacy-consent
            v-model="applicant"
            :index="index"
            :privacy_consent="applicant.previous_privacy_consent"
            :disabled="'true'"
            :version="'Previous'"
        />
        <edit-applicant-credit-report-content
            v-model="applicant"
            :version="'Previous'"
            :index="index"
            :application="application"
        />
        </v-tab-item>

        <v-tab>Alternative</v-tab>
        <v-tab-item>
        <edit-applicant-credit-report-content
            v-model="applicant"
            :version="'Alternative'"
            :index="index"
            :application="application"
        />
        </v-tab-item>
    </v-tabs>

  </group-card>

</template>

<script>
import { mapGetters } from 'vuex';
import GroupCard from '@/components/Cards/GroupCard';
import Tabs from "@/components/Tabs";
import EditApplicantVedaReport from "./EditApplicantVedaReport";
import EditApplicantPrivacyConsent from "./EditApplicantPrivacyConsent";
import EditApplicantCreditReportContent from "./EditApplicantCreditReportContent";

export default {
  components: {
    GroupCard,
    Tabs,
    EditApplicantVedaReport,
    EditApplicantPrivacyConsent,
    EditApplicantCreditReportContent,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    index: {
      required: true,
      default: 0,
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      application: 'application',
      userHasPermission: 'userHasPermission'
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() { return this.value; },
      set(applicant) { this.$emit('input', applicant); },
    },
  },
  data() {
    return {
      tooltipText: '<li>Privacy can be sent by SMS and client can accept in real time.</li>',
    }
  }
};
</script>
<style scoped lang="scss">
.v-tab--active {
    color: white !important;
    background-color: #0b0e3c;
    font-weight: bold !important;
}
.v-tab {
    font-size: 0.745rem !important;
    padding: 0px 28px !important;
    font-weight: bold !important;
    letter-spacing: 0.04em !important;
}
.v-tab:before {
    background-color: transparent !important;
}
</style>
